// extracted by mini-css-extract-plugin
export default {"container":"ColorectalCancerScreening_container__0K7rn","back-btn":"ColorectalCancerScreening_back-btn__qXunq","back-icon":"ColorectalCancerScreening_back-icon__UgXoK"};